import { render, staticRenderFns } from "./WheelSelectModal.vue?vue&type=template&id=f635b21a&scoped=true"
import script from "./WheelSelectModal.vue?vue&type=script&lang=js"
export * from "./WheelSelectModal.vue?vue&type=script&lang=js"
import style0 from "./WheelSelectModal.vue?vue&type=style&index=0&id=f635b21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f635b21a",
  null
  
)

export default component.exports